const timelineKeys = {
  ITimelineService: Symbol.for('@timeline/ITimelineService'),
  TimelineService: Symbol.for('@timeline/TimelineService'),
};

export default timelineKeys;
